import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595a61d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-help-title pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-help-body" }
const _hoisted_3 = { class: "mxa-help-body" }

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpOther',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.help.other.title')), 1),
    _createVNode(BaseAccordion, {
      accordionId: "helpOther1",
      headerTitle: _ctx.$t('body.help.other.1.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.other.1.body.1')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpOther2",
      headerTitle: _ctx.$t('body.help.other.2.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.other.2.body.1')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"])
  ], 64))
}
}

})